import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { signupSearchParams } from 'router/search/signup';
import { beforeLoadSignupSubRoute, headSignupSubRoute } from 'router/utils';
import { validateBusinessDetailsLeadStatus } from 'router/validateLeadStatus';

export const Route = createFileRoute('/_signup/gym/business-details')({
  validateSearch: zodValidator(signupSearchParams),
  head: headSignupSubRoute,
  beforeLoad: ({ context, location, preload, cause }) => {
    return beforeLoadSignupSubRoute({
      context,
      location,
      preload,
      cause,
      validateLeadStatus: validateBusinessDetailsLeadStatus,
    });
  },
});
